var _style, _defs, _defs2, _defs3, _defs4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.47 20.42",
    style: {
      enableBackground: "new 0 0 23.47 20.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000119105351372385171650000017852636634513985677_);}\n\t.st1{clip-path:url(#SVGID_00000025431368523157354960000005389319916475495820_);fill:#869999;}\n\t.st2{clip-path:url(#SVGID_00000044148182887612797520000008022748221088161934_);}\n\t.st3{clip-path:url(#SVGID_00000027580634075770787310000016069269951211167618_);fill:#869999;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -972.53,
    y: -611.38,
    width: 1440,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036240218712425347000000017622223312839202968_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036240218712425347000000017622223312839202968_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000175284954044267902340000002588868900098646406_",
    d: "M14.38,4l-5.17,4L4.03,4H14.38z M2.88,4.91l5.88,4.55 C8.89,9.56,9.05,9.61,9.2,9.61s0.31-0.04,0.44-0.15l5.88-4.55v2.68c0.4-0.09,0.82-0.13,1.24-0.13h0.18V3.31 c0-0.39-0.33-0.69-0.73-0.69H2.17c-0.4,0-0.71,0.3-0.71,0.69v9.29c0,0.39,0.31,0.69,0.71,0.69h8.62c0-0.48,0.07-0.93,0.18-1.39 H2.88L2.88,4.91z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131354645223621614690000017131052412237380540_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175284954044267902340000002588868900098646406_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.47,
    y: 1.62,
    style: {
      clipPath: "url(#SVGID_00000131354645223621614690000017131052412237380540_)",
      fill: "#869999"
    },
    width: 17.47,
    height: 12.67
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165936572753349808000000004276411753857447316_",
    x: -972.53,
    y: -610.58,
    width: 1440,
    height: 1080
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112633487440339220030000015070707248316861614_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165936572753349808000000004276411753857447316_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112633487440339220030000015070707248316861614_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000124131784952925278170000006456548716679516587_",
    d: "M22.09,13.83h-0.91c-0.13-2.29-2.06-4.11-4.42-4.11 c-2.45,0-4.44,1.95-4.44,4.35s1.99,4.35,4.44,4.35c0.57,0,1.15-0.11,1.68-0.32c0.35-0.15,0.53-0.54,0.4-0.91 c-0.15-0.35-0.55-0.52-0.93-0.39c-0.35,0.15-0.75,0.22-1.13,0.22c-1.68,0-3.03-1.32-3.03-2.97s1.35-2.97,3.03-2.97 c1.59,0,2.87,1.19,3.01,2.71h-0.84c-0.29,0-0.46,0.3-0.31,0.56l1.59,2.55c0.15,0.24,0.49,0.24,0.64,0l1.55-2.51 C22.56,14.15,22.38,13.83,22.09,13.83L22.09,13.83z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109711613107194547180000010058243089939995070_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124131784952925278170000006456548716679516587_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.32,
    y: 8.71,
    style: {
      clipPath: "url(#SVGID_00000109711613107194547180000010058243089939995070_)",
      fill: "#869999"
    },
    width: 12.15,
    height: 10.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendEmail);
export default __webpack_public_path__ + "static/media/resend-email.20d55d3a9537b73a48340762322bd7f3.svg";
export { ForwardRef as ReactComponent };